import {createFileRoute} from '@tanstack/react-router';
import {BillPaymentOptionsPage} from 'features/bill-payment/pages/BillPaymentOptionsPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/options',
)({
  component: BillPaymentOptionsPage,
  validateSearch: (search) => {
    return {
      method: search.method as string | undefined,
    };
  },
});
